/**
 * WebSocket close codes of our own, in the 4100+ range so they can never
 * collide with the codes Colyseus reserves (4000–4010) or the standard ones.
 *
 * A client that sees one of these knows the server ended the session on
 * purpose and must not try to reconnect.
 */
/** The same character logged in from somewhere else; this session lost. */
export const CLOSE_CODE_SESSION_REPLACED = 4100;
/**
 * The player walked through an exit: the server saved them in the next zone
 * and closes this room; the client joins the zone it was told (`zone_change`).
 */
export const CLOSE_CODE_ZONE_CHANGE = 4101;
/** An admin sent the player away (ADR 0037); they may come back. */
export const CLOSE_CODE_KICKED = 4102;
/** The account is banned (ADR 0037): the client says so and does not reconnect. */
export const CLOSE_CODE_BANNED = 4103;
/** Too many faults in a minute (ADR 0040): flooding, impossible moves. */
export const CLOSE_CODE_FLOOD = 4104;
/**
 * The server is restarting (a deploy): the countdown announced by
 * `server_restart` ran out and the character is saved. The client waits for
 * the server to answer again, then rejoins on its own.
 */
export const CLOSE_CODE_SERVER_RESTART = 4105;
//# sourceMappingURL=session.js.map